import { useGetProjectsQuery } from '@/api/serverApi'
import BrowseProjectsView from '@/components/browse-views/projects/BrowseProjectsView'
import { Navbar } from '@/components/header'
import ViewPicker from '@/components/browse-views/view-picker/ViewPicker'
import useSelectView from '@/hooks/useSelectView'
import { Meta, PaginationBar, SearchIcon, SortDirections, TextInput, usePagination, useSearch, useSort } from '@cfs-fixings/shared'
import { useDebouncedCallback } from 'use-debounce'
import { MinimalSelect } from '@cfs-fixings/shared/src/components/dropdown-input'
import CreateButtonHeader from '@/components/header/CreateButtonHeader'

const textSpec = {
  header: 'Projects',
  searchPlaceholder: 'Search projects',
  sortByPrefix: 'Sort by',
  newestFirst: 'Newest First',
  oldestFirst: 'Oldest First',
}

const sortOptions = [
  { value: SortDirections.descending, label: textSpec.newestFirst },
  { value: SortDirections.ascending, label: textSpec.oldestFirst },
]

const BrowseProjectsPage = () => {
  const { currentPage, setPage, itemsPerPage, setItemsPerPage } = usePagination({})

  const { searchTerm, setSearchTerm } = useSearch()
  const { sortDirection, setSortDirection } = useSort()
  const { viewType, setViewType } = useSelectView({ initialViewType: 'grid' })

  const debouncedSetSearchTerm = useDebouncedCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value),
    500,
  )

  const { data: response, isFetching: isFetchingProjects } = useGetProjectsQuery({ page: currentPage, perPage: itemsPerPage, search: searchTerm, sortDirection: sortDirection, sortBy: 'created' })

  return <>
    <Meta title="Projects" />

    <Navbar
      topbar={
        <CreateButtonHeader>
          <h1 className="font-semibold text-[24px] text-gray-900">{textSpec.header}</h1>
        </CreateButtonHeader>
      }
    >
      <div className="flex flex-col justify-between w-full gap-4">
        <div className="flex flex-col w-full">
          <div className="grid grid-cols-2 pb-8 px-2.5">
            <TextInput
              prefixIcon={
                <SearchIcon className="w-[16px] h-[16px] text-gray-600" />
              }
              placeholder={textSpec.searchPlaceholder}
              onChange={debouncedSetSearchTerm}
            />
            <div className="flex justify-end items-center">
              <div className="flex items-center justify-end gap-2.5 pr-[38px]">
                <p className="text-sm leading-[19.6px]">{textSpec.sortByPrefix}</p>
                <MinimalSelect
                  defaultValue={sortDirection}
                  options={sortOptions}
                  onChange={(option) => setSortDirection?.(option.value)}
                />
              </div>
              <ViewPicker
                selectedOption={viewType}
                onOptionSelected={(viewType) => setViewType(viewType)}
              />
            </div>
          </div>
          <BrowseProjectsView
            viewType={viewType}
            projects={response?.data}
            isLoading={isFetchingProjects}
          />
        </div>
        <div className="px-2 md:px-0">
          <PaginationBar
            prefix="customers"
            currentPage={currentPage}
            lastPage={response?.meta?.last_page ?? 1}
            total={response?.meta?.total ?? 1}
            from={response?.meta?.from}
            to={response?.meta?.to}
            onPageChange={(pageNum) => setPage(pageNum)}
            onRowsPerPageChange={(rowsPerPage) => setItemsPerPage(rowsPerPage)}
          />
        </div>
      </div>


    </Navbar>
  </>
}

export default BrowseProjectsPage
